import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ellipsisMultiline } from '@/styles/helpers';

export const Box = styled.div`
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.tertiary.background};
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-radius: 7px;
  margin: 10px 15px;
  display: flex;
  gap: 5px;
`;

export const Text = styled(Typography.Title)`
  ${ellipsisMultiline(1)};
  margin-top: 5px;
`;
